import { useRoleBasedAuth } from '../contexts/RoleBasedAuthContext';

interface UserRole {
  isAdmin: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export const useUserRole = (): UserRole => {
  // Use our role-based auth context which handles the PingFederate group claims
  const { isAdmin, isAuthenticated, isLoading } = useRoleBasedAuth();

  return {
    isAdmin,
    isAuthenticated,
    isLoading
  };
};

export default useUserRole;
